import { Card, CardContent } from 'app-template-lib/components/shadcn';

/**
 * 利用規約
 * @returns
 */
export default function TermsOfService() {
    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100 p-4">
            <Card className="max-w-4xl w-full p-6">
                <h2 className="text-2xl font-bold mb-4">利用規約</h2>

                <CardContent className="p-4 h-full overflow-y-auto bg-white rounded">
                    <div className="container mx-auto p-6 max-w-4xl">
                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">1. 当ウェブサイトのコンテンツの利用について</h2>
                            <p>
                                当ウェブサイトで公開している情報（以下「コンテンツ」といいます。）は、琴浦町の許可なく複製、公衆送信、翻訳・変形等の翻案、商用利用を行うことはできません。
                            </p>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">2. 出典の記載について</h2>
                            <p>コンテンツを利用する際は出典を記載してください。記載例は以下のとおりです。</p>
                            <ul className="list-disc list-inside ml-4">
                                <li>出典：琴浦町ウェブサイト（当該ページの URL）</li>
                            </ul>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">3. 第三者の権利を侵害しないこと</h2>
                            <p>
                                コンテンツには第三者が著作権その他の権利を有している場合があります。特に権利処理済であることが明示されていないものは、利用者の責任で権利者から許諾を得てください。
                            </p>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">4. 個別法令による利用の制約</h2>
                            <p>一部のコンテンツには、個別法令により利用に制約がある場合があります。詳細は該当ページをご参照ください。</p>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">5. 準拠法と合意管轄</h2>
                            <p>
                                本利用規約は日本法に基づき解釈されます。また、琴浦町を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
                            </p>
                        </section>

                        <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">6. 免責事項</h2>
                            <p>
                                琴浦町は、利用者がコンテンツを利用して行う一切の行為について責任を負いません。また、コンテンツは予告なく変更・削除される場合があります。
                            </p>
                        </section>

                        {/* <section className="mb-6">
                            <h2 className="text-xl font-semibold mb-2">7. その他</h2>
                            <p>
                                本利用規約は、クリエイティブ・コモンズ・ライセンス（CC BY 4.0）と互換性があり、CC
                                BYに従うことでも利用できます。
                            </p>
                        </section> */}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
